module.exports = __webpack_public_path__ + "static/media/navbar.3a696c59.svg";